/**
 * The phase of the moving red hatch (R1749, `styles.css` `fault-hatch`).
 *
 * The chrome rewrites the hosts of the hatch about once a second: the time
 * cell writes the seconds of the world clock, and that rewrite takes the
 * drain line out of the top bar and appends it again. A CSS animation
 * starts again from its first frame when its element enters the page, so
 * the stripes jumped back once a second.
 *
 * `alignHatches` sets the start of every hatch animation to 0 on the page
 * timeline. The phase is then a function of the wall clock alone, and a new
 * hatch continues where the old one stopped. A caller runs it right after
 * the write, before the next paint.
 */
export const HATCH_ANIMATION = 'fault-hatch';

export function alignHatches(doc: Document = document): void {
  if (typeof doc.getAnimations !== 'function') return;
  for (const a of doc.getAnimations()) {
    if ((a as CSSAnimation).animationName === HATCH_ANIMATION && a.startTime !== 0) a.startTime = 0;
  }
}
